export const PHASE_DRAG_TYPE = 'phase';

export interface PhaseDragItem {
  jobId: string; // parent job UUID (job.parentJobId)
  phaseId: string; // job.phaseId
  startDate: string; // yyyy-MM-dd
  durationDays: number;
  name: string;
  ion: string | null;
}
